export default "__VITE_ASSET__BLXbs7sX__"